/* ==========================================================================
   CalendarRxjs > Client > Clear
   ========================================================================== */

/* Modules */
const { toNode } = require('@bluekiri/alexandria/helpers/domHelpers');
const { addData, addStyle } = require('@bluekiri/alexandria/helpers/dataHelpers');

const ButtonTemplate = require('../../../../button-rxjs/template');
const Button = require('../../../../button-rxjs/client/js');

const configuration = require('../config');

/* Create clear */
function createClear(instance) {
    /* Data */
    const { context } = instance.config;

    /* Template */
    const template = ButtonTemplate(
        addStyle(
            addData(
                {
                    icon: configuration().icon.cancel
                },
                {
                    type: configuration().type.clear
                }
            ),
            [configuration().css.clear]
        ),
        context
    );

    /* Node */
    const node = toNode(template)[0];

    /* Return */
    return node;
}

/* Add clear */
function addClear(instance) {
    const panel = instance;

    /* Data */
    const { selector } = instance;

    /* Node */
    const node = createClear(instance);

    /* Add to DOM */
    instance.element.appendChild(node);

    /* Init */
    panel.clear = Button(`${selector} [data-component='ButtonRxjs'][data-type='${configuration().type.clear}']`);

    /* Update subscriptions */
    panel.subscriptions = {
        ...panel.subscriptions,
        clear: instance.clear.events.click$.subscribe(event => {
            event.stopPropagation();

            /* Clear fp */
            instance.fp.clear();

            /* Dispatch action to clean */
            instance.actions.setValue(null);

            /* Destroy clear */
            destroyClear(instance);
        })
    };

    /* Animate */
    setTimeout(() => instance.clear.element.classList.add('is-visible'), 50);
}

/* Destroy clear */
function destroyClear(instance) {
    const panel = instance;

    /* Destroy */
    instance.clear.actions.destroy();

    /* Clean subscriptions */
    instance.subscriptions.clear.unsubscribe();
    delete panel.subscriptions.clear;

    /* Clean reference */
    delete panel.clear;
}

/* Exports */
module.exports = {
    addClear,
    destroyClear
};
